import
  React, {
  useEffect,
  useState
} from 'react';

import {
  useHistory,
  useParams
} from 'react-router-dom';

import {
  Image,
  Text,
  VContainer,
  VContainerVH,
  VFillContainer
} from '@vodacom/web-common';

import {
  Environment
} from '@vodacom/web-env';

import {
  BackButton,
  PrimaryButton
} from 'components';

import {
  HandleRender
} from 'hocs';

import {
  DrupalProvider
} from 'providers';

import {
  CacheKeys
} from '../../../constants';

import {
  useRedirectHandler
} from 'helpers';

export const WhatsNewContent = () => {

  const history = useHistory();
  const redirectHandler = useRedirectHandler();

  const { content_id } = useParams();

  const [
    state,
    setState
  ] = useState({
    item: null,
    isLoading: true,
    isError: false
  });

  const getCachedData = async () => {

    if (content_id) {

      const cachedItem = await DrupalProvider.getCachedItem(CacheKeys.WhatsNew, null, DrupalProvider.getWhatsNew);

      if (cachedItem && cachedItem.ok && cachedItem?.result?.[0]?.content) {

        setState(prevState => ({
          ...prevState,
          item: cachedItem?.result?.[0]?.content?.find(i => i.id === content_id),
          isLoading: false
        }));

        return;
      }

      setState(prevState => ({
        ...prevState,
        isError: true,
        isLoading: false
      }));
    }
  };

  useEffect(() => {

    if (!state.item) {

      const init = async () => {

        await getCachedData();
      };

      init();
    }
  }, []);

  const WhatsNew = () => {

    return (

      <VFillContainer>

        <VContainer>

          <Image
            width={'100%'}
            height={'auto'}
            src={`${Environment.current.drupalBaseUrl}${state.item?.image}`} />
        </VContainer>

        <BackButton
          onClick={() => history.goBack()} />

        <VFillContainer
          padding={'0 16px'} >

          <Text
            padding={'0'}
            fontSize={'20px'}
            fontWeight={'bold'}>
            {state.item?.title}
          </Text>

          <Text
            dangerouslySetInnerHTML={{
                __html: state.item?.main_content
              }} />
        </VFillContainer>

        <VContainerVH
          margin={'0'}
          padding={'35px 28px 50px'}
          width={'100%'}
          boxSizing={'border-box'}>

          <PrimaryButton
            text={'Take me there'}
            onClick={() => {

              redirectHandler(
                history.location,
                `/redirect?targetUrl=${encodeURIComponent(state.item?.url)}&` +
                `isZeroRated=${state.item?.isZeroRated}`,
                state.item?.isZeroRated
              );
            }}/>
        </VContainerVH>
      </VFillContainer>
    );
  };

  return (

    <HandleRender
      isLoading={state.isLoading}
      isError={state.isError}>

      <WhatsNew/>
    </HandleRender>
  );
};
